const base = "https://cdn.dnaracing.run/imgs";
export const baseimgmap = {
  lose: `${base}/lose.png`,
  win: `${base}/win.png`,
};
